import { LoginForm } from "@/features/authenticate/components/loginForm";
import { Container, Stack } from "@mantine/core";

export const LoginPage = () => {
	return (
		<Container
			size="xl"
			style={{
				height: "100vh",
			}}
		>
			<Stack align="center" justify="center" h="100%">
				<LoginForm />
			</Stack>
		</Container>
	);
};
